<template>
	<nav class="navbar navbar-expand-lg fixed-top navbar-light bg-light">
		<button class="navbar-toggler"
				type="button" data-toggle="collapse"
				data-target="#navbarSupportedContent"
				aria-controls="navbarSupportedContent"
				aria-expanded="false"
				aria-label="Toggle navigation">
			<span class="navbar-toggler-icon"></span>
		</button>
		<router-link :to="{name: 'home'}" class="d-lg-none navbar-brand" tag="a">
			<img src="../assets/images/logobiale-sm.png" width="183" height="59" alt="Logo Fahu Meble">
		</router-link>
		<div class="collapse navbar-collapse" id="navbarSupportedContent">
			<div class="mx-auto">
				<ul class="navbar-nav">
					<router-link :to="{name: 'designers'}" @click.native="menuClick" tag="li" class="nav-item pt-lg-5 pl-md-3 pr-md-3">
						<a class="nav-link">Projektanci</a>
					</router-link>
					<router-link :to="{name: 'galleries'}" @click.native="menuClick" tag="li" class="nav-item pt-lg-5 pl-md-3 pr-md-3">
						<a class="nav-link">Realizacje</a>
					</router-link>
					<router-link :to="{name: 'services'}" @click.native="menuClick" tag="li" class="nav-item pt-lg-5 pl-md-3 pr-md-3">
						<a class="nav-link">Usługi</a>
					</router-link>
					<router-link :to="{name: 'home'}" @click.native="menuClick" class="nav-item d-none d-md-block pl-md-3 pr-md-3" tag="li">
						<a class="nav-link">
							<img src="../assets/images/logobiale.png" width="215" height="85" alt="Logo Fahu Meble">
						</a>
					</router-link>
					<router-link :to="{name: 'about'}" @click.native="menuClick" class="nav-item pt-lg-5 pl-md-3 pr-md-3" tag="li">
						<a class="nav-link">O mnie</a>
					</router-link>
					<router-link :to="{name: 'contact'}" @click.native="menuClick" class="nav-item pt-lg-5 pl-md-3 pr-md-3" tag="li">
						<a class="nav-link">Kontakt</a>
					</router-link>
					<router-link :to="{name: 'orders'}" @click.native="menuClick" class="nav-item pt-lg-5 pl-md-3 pr-md-3" tag="li">
						<a class="nav-link">Partnerzy</a>
					</router-link>
				</ul>
			</div>
		</div>
	</nav>
</template>

<script>
	import "popper.js";
	import "bootstrap";

	export default {
		methods: {
			menuClick () {
				$('#navbarSupportedContent').collapse('hide');
			}
		}
	};
</script>
